import { useMutation, useQueryClient } from "@tanstack/react-query"
import { updateBrandColors } from "sdk/brand"
import { brandKeys, useBrandColors } from "sdk/brand/queries"

const HEX_COLOR = /^#[0-9a-f]{6}$/i

/**
 * Saves the account's saved colors, and writes through to the legacy
 * `window.app.user.colors` global so not-yet-migrated pickers stay fresh.
 */
export function useUpdateBrandColors(options = {}) {
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: updateBrandColors,
    async onSuccess(colors, ...rest) {
      if (window.app?.user) window.app.user.colors = colors
      queryClient.invalidateQueries({ queryKey: brandKeys.colors() })
      await options.onSuccess?.(colors, ...rest)
    }
  })
}

export function useAddBrandColor() {
  const { data: colors = [] } = useBrandColors()
  const { mutate } = useUpdateBrandColors()

  return color => {
    // Guard the two cases the "+" can still be clicked in but the server would
    // reject: a non-hex value (e.g. "transparent") and a color already saved.
    if (!HEX_COLOR.test(color)) return
    const normalized = color.toUpperCase()
    if (colors.includes(normalized)) return
    mutate([...colors, normalized])
  }
}
